<template>
  <div class="wrapperlsjz">

        <Module ref="Module"
        :title="''"
        :desc="''"
        :emptyTitle="'暂无数据'"
        :moreTitle="'更多历史净值'"
        :fetchCache="fetchCache"
        :fetchRequest="fetchRequest"
        :loadStyle="'height: 315px'"
        :checkData="checkData"
        :moreEvent="clickMore">
          <div slot-scope="slotProps">
            <div class="single top">
              <span class="period">日期</span>
              <span class="syl">单位净值</span>
              <span class="avg">累计净值</span>
              <span class="rank">日涨幅
                <img class="tip-icon-t"
                  @click="showTips"
                  src="../assets/warn-tip-gray.png" v-if="showTipAlet"/>
              </span>
            </div>
            <div class="single bottom"
            v-for="(item, index) in slotProps.list" v-bind:key="index">
              <div class="period">
                <div>{{item.FSRQ}}</div>
                <div class="fh-tip" v-if="showFhTip(item.sorFSRQ,fhDatalist)">分红</div>
              </div>
              <span class="syl">{{item.DWJZ}}</span>
              <span class="avg">{{item.LJJZ}}</span>
              <span :class="['rank', `${upDown(item.JZZZL)}`]"
              >{{`${upConfigureSyl(item.JZZZL)}`}}</span>
            </div>
          </div>
        </Module>
  </div>
</template>

<style lang="less" scoped>
.wrapperlsjz {
  background-color: white;
  padding-left: 24px;
  padding-right: 24px;
  border-radius: 12px;
}
.single {

  font-family: DINAlternate-Bold;
  display: flex;
  font-size: 30px;
  align-items: center;
  justify-content: space-between;
  height: 90px;
}
.gray {
  color: @app-color-stay;
}
.red {
  color: @app-color-up;
}
.green {
  color: @app-color-down;
}
.top {
  font-family: PingFangSC-Regular;
  color: #999999;
  font-size: 28px;
  .period {
    text-align: left;
    width: 24%;
  }
  .syl {
    text-align: center;
    width: 26%;
  }
  .avg {
    text-align: center;
    width: 26%;
  }
  .rank {
    display: flex;
    text-align: right;
    white-space:nowrap;
    width: 24%;
    align-items: center;
  justify-content: flex-end;
  }
}
.bottom {
  font-size: 32px;
  .period {
    text-align: left;
    flex-direction: row;
    display: flex;
    width: 24%;
  }
  .syl {
    // text-align: left;
    // background-color: orange;
    text-align: center;
    width: 26%;
  }
  .avg {
    // background-color: cyan;
    text-align: center;
    width: 26%;
  }
  .rank {
    text-align: right;
    width: 24%;
  }
}
.more-wrapper {
  background-color: #ffffff;
  border-top: 1px solid #eeeeee;
  padding: 30px;
}

.more-text {
  font-size: 30px;
  color: #008aff;
  text-align: center;
  line-height: 30px;
}

.tip-icon-t{
  height: 23px;
  width: 23px;
  margin-left: 10px;
}
.fh-tip{
  flex: 1;
  margin-left: 10px;
  width: 56px;
  background: rgba(255, 100, 52, 0.1);
  border-radius: 4px;
  font-size: 20px;
  color: rgb(255, 100, 52);
  text-align: center;
  padding-top: 4px;
  padding-bottom: 4px;
}
</style>

<script>
import Module from '@/components/Module.vue';
import StoreManger from '@/utils/FundHQJHManger';
import JS from '@/base/JSTool';
import FundTypeSearch from '@/utils/FundTypeSearch';
import {
  detailPushPage,
} from '@/utils/nativeBridge';

export default {
  name: 'mark-period-increase',
  components: {
    Module,
  },
  props: {},
  watch: {},
  data() {
    return {
      fundCode: '',
      fundType: '',
      showTipAlet: false,
      fhDatalist: [],
    };
  },
  computed: {},
  created() {
  },
  mounted() {
    // this.render();
  },
  methods: {
    mainQueryError() {
      this.$refs.Module.showMainError();
    },
    render() {
      this.fundCode = this.$store.state.native.fund.fundCode;
      this.fundType = this.$store.state.native.fund.fundType;
      if (this.needRequestData()) {
        this.$refs.Module.start();
      } else {
        this.$refs.Module.cache();
      }
    },
    needRequestData() {
      const fundId = this.$store.state.quotation.fund[`${this.fundCode}NetList`];
      let needReq = true;
      if (fundId) {
        if (fundId.ctime) {
          const now = new Date().getTime();
          const during = now - fundId.ctime;
          if (during < 2 * 60 * 1000) {
            needReq = false;
          }
        }
      }
      return needReq;
    },
    fetchCache() {
      this.fundCode = this.$store.state.native.fund.fundCode;
      const fundId = this.$store.state.quotation.fund[`${this.fundCode}NetList`];
      return this.handleData(fundId);
    },
    fetchRequest() {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch('updateNetList', { id: this.fundCode, isShareNet: false })
          .then((res) => {
            const resData = this.handleData(res);
            resolve(resData);
          })
          .catch(() => {
            reject();
          });
      });
    },
    checkData(data) {
      return (data && Object.prototype.toString.call(data) === '[object Array]' && data.length > 0);
    },
    showFhTip(sorFSRQ, fhDatalist) {
      if (sorFSRQ && fhDatalist && fhDatalist.length > 0) {
        const lists = fhDatalist.join(',');
        if (lists) {
          return (lists.indexOf(sorFSRQ) !== -1);
        }
      }
      return false;
    },
    handleDefault() {
    },
    handleData(data) {
      const arr = [];
      if (data && data.Datas) {
        if (data.Expansion && data.Expansion.BonusList && data.Expansion.BonusList.length > 0) {
          const charr = [];
          data.Expansion.BonusList.forEach((el) => {
            charr.push(el.FSRQ);
          });
          this.fhDatalist = charr;
        }
        const list = data.Datas;
        if (list) {
          if (list.slice) {
            let newList = list;
            if (list.length >= 5) {
              newList = list.slice(0, 5);
            }
            newList.forEach((el) => {
              if (el.JZZZL === '--') {
                this.showTipAlet = true;
              }
              arr.push(this.format(el));
            });
          }
        }
      }
      return arr;
    },
    format(item) {
      const fetch = (key) => {
        const res = JS.fetchString(item, key);
        return res || '--';
      };
      return {
        FSRQ: fetch('FSRQ').substring(5),
        sorFSRQ: fetch('FSRQ'),
        DWJZ: fetch('DWJZ'),
        LJJZ: fetch('LJJZ'),
        JZZZL: fetch('JZZZL'),
      };
    },
    upDown(value) {
      const newV = parseFloat(value);
      if (newV > 0) {
        return 'red';
      }
      if (newV < 0) {
        return 'green';
      }
      return 'gray';
    },
    upConfigureSyl(value) {
      if (value === '--') {
        return '--';
      }
      return `${parseFloat(value).toFixed(2)}%`;
    },
    showTips() {
      this.$feedback.showModal({
        title: '日涨幅为空原因',
        content: '1、非交易日净值不参与日涨幅计算（灰色数据行）。\n2、上一交易日净值未披露，日涨幅无法计算。',
        confirmText: '知道了',
        confirmColor: '#f40',
        showCancel: false,
      });
    },
    clickMore() {
      const baseInfo = StoreManger.getFundJJXQ();
      const name = StoreManger.getFundJJXQNAME(baseInfo);
      const code = StoreManger.getFundJJXQCODE(baseInfo);
      const isM = FundTypeSearch.isMonetaryfund(this.fundCode);

      let url = `fund://mp.1234567.com.cn/weex/516939c37bdb4ba2b1138c50cf69a2e1/pages/FundHistoryNetWorth?fundCode=${code}&fundName=${name}`;
      if (isM) {
        url = `fund://mp.1234567.com.cn/weex/516939c37bdb4ba2b1138c50cf69a2e1/pages/FundHistoryIncome?fundCode=${code}&fundName=${name}&featuretype=${baseInfo.FEATURE}`;
      }
      detailPushPage({
        type: 2,
        url,
      });
      this.reportMonitor({
        eventName: 'pz.middle.lsjz.more',
      });
    },
  },
};
</script>
